<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="pagehd">Microsoft 365 OSMOSIS Dashboard</div>
    </div>

    <div class="p-col-12 p-sm-6 p-xl-4 overview-box total-views">
      <div class="card text-center">
        <div class="card-title">Engagement Dashboard</div>
        <p>View engagement details</p>
        <a [routerLink]="['/home']">View all</a>
      </div>
    </div>

    <div class="p-col-12 p-sm-6 p-xl-4 overview-box total-views">
      <div class="card text-center">
        <div class="card-title">Partner Dashboard</div>
        <p>View current status of your partner</p>
        <a [routerLink]="['/partner-dashboard']">Partner Information</a>
      </div>
    </div>

    <div class="p-col-12 p-sm-6 p-xl-4 overview-box total-views">
      <div class="card text-center">
        <div class="card-title">Customer Usage</div>
        <p>View customer details</p>
        <a [routerLink]="['/customer-usage']">Tenant Information</a>
      </div>
    </div>

    @if (isProdEnvironment) {
      <div class="p-col-12 p-sm-6 p-xl-4 overview-box total-views">
        <div class="card text-center">
          <div class="card-title">Download Engagement Report</div>
          <p>View download engagement report CSV format</p>
          <a [routerLink]="['/download-csv']">Download Report</a>
        </div>
      </div>
    }
  </div>
</div>
